import { render, staticRenderFns } from "./NotiBell.vue?vue&type=template&id=2ddf3dae&scoped=true"
import script from "./NotiBell.vue?vue&type=script&lang=ts"
export * from "./NotiBell.vue?vue&type=script&lang=ts"
import style0 from "./NotiBell.vue?vue&type=style&index=0&id=2ddf3dae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ddf3dae",
  null
  
)

export default component.exports